// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2a92w","image":"Header_image__rqOq7","name":"Header_name__3zBhD","info":"Header_info__2MR0l","infoRow":"Header_infoRow__1Yhwn"};